module.exports = __webpack_public_path__ + "static/media/circle.0d3ee542.svg";